var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroupQrTemp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "443px",
    height: "842px",
    viewBox: "0 0 443 842",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7QR",
    transform: "translate(-75.000000, -68.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(75.000000, 68.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 100.87,
    y: 366.36,
    width: 240.94,
    height: 20.55
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.000000, 818.000000)",
    stroke: "#000000",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "0.87 0.06 26.38 0.06 26.38 23.08"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "34.89 23.08 34.89 8.57 0.87 8.57"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.000000, 0.000000)",
    stroke: "#000000",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "0.87 23.36 26.38 23.36 26.38 0.35"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "34.89 0.35 34.89 14.86 0.87 14.86"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(406.000000, 0.000000)",
    stroke: "#000000",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "34.41 23.36 8.89 23.36 8.89 0.35"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "0.39 0.35 0.39 14.86 34.41 14.86"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(406.000000, 818.000000)",
    stroke: "#000000",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "34.41 0.06 8.89 0.06 8.89 23.08"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "0.39 23.08 0.39 8.57 34.41 8.57"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 384.000000)",
    stroke: "#000000",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.89,36.71 L24.89,36.71",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.89,0.71 L18.89,72.71",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(418.000000, 384.000000)",
    stroke: "#000000",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.39,36.71 L0.39,36.71",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.39,72.71 L6.39,0.71",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(185.000000, 0.000000)",
    stroke: "#000000",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.64,5.36 L72.64,5.36",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.64,0.36 L36.64,11.36",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(185.000000, 830.000000)",
    stroke: "#000000",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.64,6.06 L0.64,6.06",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.64,12.06 L36.64,0.06",
    id: "Path"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#B2B2B2",
    strokeWidth: 0.8,
    x: 37.39,
    y: 23.86,
    width: 368.5,
    height: 793.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.48,477.41 L39.98,477.41",
    id: "Path",
    stroke: "#B2B2B2",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.96,477.41 L400.81,477.41",
    id: "Path",
    stroke: "#B2B2B2",
    strokeWidth: 0.8,
    strokeDasharray: "4.977,4.977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.3,477.41 L405.8,477.41",
    id: "Path",
    stroke: "#B2B2B2",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.48,647.49 L39.98,647.49",
    id: "Path",
    stroke: "#B2B2B2",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.96,647.49 L400.81,647.49",
    id: "Path",
    stroke: "#B2B2B2",
    strokeWidth: 0.8,
    strokeDasharray: "4.977,4.977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.3,647.49 L405.8,647.49",
    id: "Path",
    stroke: "#B2B2B2",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 207.36,
    y: 471.75,
    width: 28.55,
    height: 11.31
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 207.36,
    y: 473.69,
    width: 28.55,
    height: 7.43
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(209.959200, 472.281200)",
    fill: "#666666",
    fontFamily: "HiraginoSans-W3, Hiragino Sans",
    fontSize: 7.4862,
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("text", {
    id: "\\u5C71"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7
  }, "\u5C71")), /*#__PURE__*/React.createElement("text", {
    id: "\\u6298"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 8.23,
    y: 7
  }, "\u6298")), /*#__PURE__*/React.createElement("text", {
    id: "\\u308A"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 15.87,
    y: 7
  }, "\u308A"))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 207.36,
    y: 641.83,
    width: 28.55,
    height: 11.31
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 207.36,
    y: 643.77,
    width: 28.55,
    height: 7.43
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(209.959200, 642.360000)",
    fill: "#666666",
    fontFamily: "HiraginoSans-W3, Hiragino Sans",
    fontSize: 7.4862,
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("text", {
    id: "\\u5C71"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7
  }, "\u5C71")), /*#__PURE__*/React.createElement("text", {
    id: "\\u6298"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 8.23,
    y: 7
  }, "\u6298")), /*#__PURE__*/React.createElement("text", {
    id: "\\u308A"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 15.87,
    y: 7
  }, "\u308A"))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupQrTemp);
export default __webpack_public_path__ + "static/media/group_qr_temp.7413db7f44a6f6f25bd3830f08c9b9c2.svg";
export { ForwardRef as ReactComponent };